<template>
  <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.098 10.25 5.5 6.5h5.196l-2.598 3.75Z" fill="currentColor" />
  </svg>
</template>
